let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6Y9Qi")).then(() => parcelRequire('e5QcC'));